<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
   <div>
       <Breadcrumbs main="Gerneral Sliders" title="Gerneral Sliders" />

      <div class="container-fluid">
         <div class="row">
            <div class="col-sm-12">
               <div class="card">
                  <div class="card-body">

                     <div class="col-md-12 project-list  page-subtitle">
                           <div class="row">
                              <div class="col-md-10 d-flex">
                                 <span style="font-size: 20px; font-weight: bolder;">Manage Gerneral Sliders</span>
                              </div>
                              <div class="col-md-2">
                                 <button class="btn btn-primary" type="button" data-original-title="test" @click="openModal">Add Slider</button>
                              </div>
                              
                           </div>
                     </div>

                     <div class="col-md-12 project-list filter-sort">
                           <div class="row">
                              <div class="col-md-9 d-flex">
                                 <label class="d-flex listing-length"><span>Show</span>
                                    <select class="form-select"  v-model="listing_length" @change="fetchSliders()">
                                       <option value="5">5</option>
                                       <option value="10">10</option>
                                       <option value="20">20</option>
                                    </select>
                                    <span>entries</span>
                                 </label>
                              </div>
                              
                              <div class="col-md-3">
                                    <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchSliders()"/>
                              </div>
                           </div>
                     </div>

                     <div class="table-responsive product-table">
                        <table class="display" id="basic-1">
                           <thead>
                              <tr>
                                 <th>ID</th>
                                 <th>Image</th>
                                 <th>Status</th>
                                 <th>Options</th>
                              </tr>
                           </thead>
                           <tbody>
                              <tr v-for="slider in sliders" :key="slider.id">
                                 <td>{{slider.slider_id}}</td>
                                 <td><img :src="$image_url + slider.image" alt="Image not found" style="width:150px;"></td>
                                 <td>
                                    <label v-if="slider.status==1">Active</label>
                                    <label v-else>Blocked</label>
                                 </td>
                                    
                                 <td>

                                    <a href="#" class="btn btn-sm btn-primary mt-2 me-1" @click.prevent="setBackURL(slider.id)">{{slider.clicks}} Clicks <i class="fas fa-angle-double-right"></i></a>

                                    <a variant="danger" class="btn btn-danger btn-sm mt-2 me-1" @click="deactivateSlider(slider)" v-if="slider.status==1">Deactivate</a>
                                    <a variant="success" class="btn btn-success btn-sm mt-2 me-1" @click="activateSlider(slider)" v-else>Activate</a>  
                                    <a variant="danger" class="btn btn-danger btn-sm mt-2 me-1" @click="deleteSlider(slider.id)">Delete</a>
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                     </div>

                      <!----pagination starts --->
                      <nav aria-label="Page navigation" class="mt-2">                    
                        <ul class="pagination">
                           <li class="page-item" v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                              <a class="page-link" href="#" @click.prevent="fetchSliders(page.url + '&limit='+ listing_length + '&keyword=' + keyword)" tabindex="-1">
                                 <span v-if="index == 0">Prev</span>
                                 <span v-else-if="index == pagination.length-1">Next</span>
                                 <span v-else>{{page.label}}</span>
                              </a>
                           </li>                        
                        </ul>
                     </nav>
                     <!----pagination ends --->

                  </div>
               </div>
            </div>
         </div>
      </div>

      <DynamicModal title="Model title goes here">
			<template #body>
				<form @submit.prevent="addSlider" enctype="multipart/form-data" @hidden="clearForm()">
					<div class="col-md-12 form-group">
						<label class="control-label">Image <span class="required">*</span> <span>[Allowed Formats: jpg, jpeg, png]</span></label> 
                  <input type="file" @change="setFile" accept="image/*" class="form-control image-class" v-bind:class="{ 'is-invalid': Boolean(errors.image) }" id="fileinput">
                  <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback"> 
                     <p class="mb-0">{{val}}</p>
                  </div> 
                  <img v-if="image" class="image-preview" v-bind:src="preview_image" height="30" width="60">
					</div>

					<div class="col-md-12 mt-3 form-group">
						<button type="submit" class="btn btn-primary me-3" >Add</button>
						<button class="btn btn-light" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>

  </div>
</template>


<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

export default {
   name:'GeneralSliders',
   components: {
			DynamicModal
		},

		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},

   data() {
      return {
         sliders: [],
         
         image: null,
         preview_image: null,
         pagination: {},
         slider_status: {
            id: "",
            status: ""
         },
         keyword: "",
         showsearch: false,
         listing_length: 10,
         token: '',
         errors: {},
         delete: false,
         activate: false,
         deactivate: false,

         active_page_url: null,
      };
   },
   mounted () {
      
   },

   created() {
      this.fetchSliders();
   },

   methods: {
      fetchSliders(page_url=null) {
         this.getToken();
         let url = '/api/admin/sliders?limit=' + this.listing_length + "&keyword=" + this.keyword;
         page_url = page_url || url; 

         if(localStorage.back_url) {
            page_url = localStorage.back_url;  
            localStorage.removeItem('back_url');
         }    

         this.active_page_url = page_url; 
         this.$axios
            .get(page_url,{headers: {Authorization: 'Bearer ' + this.token,}})
            .then(res => {
               var responseData = res.data.data;
                    this.sliders = responseData.data;
                    this.pagination = responseData.links;
            })
            .catch(err => console.log(err));
      },

      openModal() {
			this.showModal();
		},

		closeModal() {
			this.hideModal();
		},

      getToken() {
         if (localStorage.getItem('slo_admin')) {
            var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
            if(slo_admin.token) {
               this.token = slo_admin.token;
               this.user = slo_admin;

            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "Login" });
            }

         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "Login" });
         }
      },


      setBackURL(slider_id) {
         localStorage.setItem('back_url', this.active_page_url);
         this.$router.push({ name: 'slider.general.clicks', params: { id: slider_id } });
      },

      setFile(e) {
            this.image = e.target.files[0];
            this.preview_image = URL.createObjectURL(this.image);
      },

      addSlider(){
         this.getToken();              
         let formData = new FormData();                  
         formData.append('image', this.image);
                     
         const config = {
              headers: {
                  'content-type': 'multipart/form-data',
                  'Authorization': 'Bearer ' + this.token,
              }
         };
         this.$axios
         .post('/api/admin/sliders/add', formData, config)
         .then(response => {
               if(response.data.status) {
                  this.$swal("", response.data.message, "success");
               } else {
                  this.$swal("", response.data.message, "error");
               }
               this.clearForm();
               this.closeModal();
               this.fetchSliders();
          })
          .catch(error => {
              if(error.response){
                  if(error.response.data.message){
                     this.errors = error.response.data.message;
                     this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
          });
               
      },

      clearForm() {
         this.image = null;
         this.preview_image = null;            
         this.errors = {};
         document.getElementById('fileinput').value = '';
      },

     

      deleteSlider(slider_id) {
         this.delete = false;
         this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to delete this slider?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
                  // this.delete = value
                  if(result.value){
                     this.getToken();
                     this.$axios
                        .get("/api/admin/sliders/delete?slider_id=" + slider_id,{headers: {Authorization: 'Bearer ' + this.token,}})
                        .then(response => {
                           if(response.data.status) {
                                 this.$swal("", response.data.message, "success");
                           } else {
                                 this.$swal("", response.data.message, "error");
                           }
                           this.fetchSliders();
                        })
                        .catch(err => console.log(err));
                  }
               })   
      },

      activateSlider(slider) {
         this.activate = false;
         this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to activate this slider?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.slider_status.id = slider.id;
                  this.slider_status.status = '1';
                  this.updateSliderStatus();
					}
					
				});
      },

      deactivateSlider(slider) {
         this.deactivate = false;
         this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to deactivate this slider?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.slider_status.id = slider.id;
                  this.slider_status.status = '0';
                  this.updateSliderStatus();
					}
				});
      },

      
      updateSliderStatus() {
         const config = {
              headers: {
                  'Authorization': 'Bearer ' + this.token,
              }
         };
         this.$axios
         .get('/api/admin/sliders/status?slider_id=' + this.slider_status.id + '&status=' + this.slider_status.status, config)
         .then(response => {
               if(response.data.status) {
                  this.$swal("", response.data.message, "success");
               } else {
                  this.$swal("", response.data.message, "error");
               }
               this.fetchSliders(this.active_page_url);
          })
          .catch(error => {
               if(error.response){
                  if(error.response.data.message){
                     this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
               
          });
      }
   }   
}
</script>